import Vue from 'vue'
import App from './App.vue'

// Element
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

// import locale from 'element-ui/lib/locale/lang/en'
import locale from 'element-ui/lib/locale/lang/es'

import router from './router';
import i18n from '@/plugins/i18n';
import store from './store'

// Inicializa los filtros, no se pasa al mount app
import filters from './filters'

Vue.use(ElementUI ,{locale})

Vue.config.productionTip = false

new Vue({
  render: h => h(App),
  router,
  store,
  i18n,
}).$mount('#app')


// agrego un interceptor para el manejo de errores
import { garantia, clientePedido } from './apiClient/index'
import { mostrarMensajeInternacionalizado } from './components/MensajeInternacionalizado'

garantia.interceptors.response.use(function (response) {
  return response;
}, function (error) {
    
  // si se produjo un error de autenticación, redirijo al login
  if(error.response.status === 401)
  {
    store.commit('sesion/setSesionExpirada', true)
  }

  // si se produjo un error de autorización, muestro una alerta
  if(error.response.status === 403)
  {
    mostrarMensajeInternacionalizado('UNAUTHORIZED')
  }

  return Promise.reject(error)
});

clientePedido.interceptors.response.use(function (response) {
  return response;
}, function (error) {
    
  // si se produjo un error de autenticación, redirijo al login
  if(error.response.status === 401)
  {
    store.commit('sesion/setSesionExpirada', true)
  }

  // si se produjo un error de autorización, muestro una alerta
  if(error.response.status === 403)
  {
    mostrarMensajeInternacionalizado('UNAUTHORIZED')
  }

  return Promise.reject(error)
});